import React from "react";

import { LottieLoading } from "../../../../../components/graphics/LottieLoading";
import { AddAutomationModal } from "../../../../work/pages/automation/AddAutomationModal";
import { TaskTemplateConfirmModals } from "../components/TaskTemplateConfirmModals";
import { TaskTemplateDetailsSection } from "../components/TaskTemplateDetailsSection";
import { TaskTemplateEditorHeader } from "../components/TaskTemplateEditorHeader";
import { TaskTemplateSubtasksSection } from "../components/TaskTemplateSubtasksSection";
import { useTaskTemplateEditorController } from "../hooks/useTaskTemplateEditorController";

export const ViewTaskTemplatePage = () => {
  const {
    isLoading,
    headerProps,
    detailsProps,
    subtasksProps,
    modalProps,
    automationModalProps,
  } = useTaskTemplateEditorController();

  return (
    <>
      <div>
        {isLoading ? (
          <LottieLoading />
        ) : (
          <div className={"font-Manrope"}>
            <TaskTemplateEditorHeader {...headerProps} />
            <TaskTemplateDetailsSection {...detailsProps} />
            <TaskTemplateSubtasksSection {...subtasksProps} />
          </div>
        )}
      </div>
      <TaskTemplateConfirmModals {...modalProps} />
      <AddAutomationModal {...automationModalProps} />
    </>
  );
};
